import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  // Load from localStorage initially
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("theme-dark");
    return saved === "true"; // fallback = false
  });

  const [skin, setSkin] = useState(() => {
    return localStorage.getItem("theme-skin") || "emerald";
  });

  // Apply dark/light class to <html>
  useEffect(() => {
    const html = document.documentElement;
    if (isDark) {
      html.classList.add("dark");
    } else {
      html.classList.remove("dark");
    }
  }, [isDark]);

  // Apply skin class to <html>
  useEffect(() => {
    const html = document.documentElement;
    Array.from(html.classList).forEach(cls => {
      if (cls.startsWith("skin-")) html.classList.remove(cls);
    });
    html.classList.add(`skin-${skin}`);
  }, [skin]);

  // Save to localStorage on change
  useEffect(() => {
    localStorage.setItem("theme-dark", isDark);
  }, [isDark]);

  useEffect(() => {
    localStorage.setItem("theme-skin", skin);
  }, [skin]);

  // ✅ Sync theme & skin across tabs
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "theme-dark") {
        setIsDark(event.newValue === "true");
      }
      if (event.key === "theme-skin") {
        setSkin(event.newValue || "emerald");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, setIsDark, skin, setSkin }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
